import { customTv } from "#utils";

export const triggerStyles = customTv({
  base: `
    flex w-full items-center justify-between
    rounded-1 outline-none bg-primary px-lg py-xs text-label-medium leading-md-20 text-text-primary
    cursor-pointer select-none border border-outline-input-enabled
    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover
    focus:border-outline-input-focus focus:ring-1 focus:ring-outline-input-focus
  `,
  variants: {
    isDisabled: {
      true: "cursor-not-allowed bg-background-primary text-text-disabled border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled",
    },
    isReadOnly: {
      true: "!cursor-default !bg-background-secondary !border-transparent hover:ring-0 focus:ring-0",
    },
    isInvalid: {
      true: "border-outline-negative ring-1 ring-outline-negative",
    },
    isOpen: {
      true: "border-outline-input-focus ring-1 ring-outline-input-focus",
    },
    uiVersion: {
      v1: "px-xs py-xxs rounded-xs text-label-small border-legacy-navy-L50 hover:ring-0 hover:border-legacy-navy-base focus:border-legacy-orange-base focus:!ring-legacy-orange-base",
      v2: "",
    },
  },
  compoundVariants: [
    {
      uiVersion: "v1",
      isInvalid: true,
      class: "border-outline-negative ring-1 ring-outline-negative",
    },
    {
      uiVersion: "v1",
      isOpen: true,
      class: "border-legacy-orange-base ring-1 ring-legacy-orange-base",
    },
    {
      uiVersion: "v1",
      isReadOnly: true,
      class: "hover:ring-0",
    },
    {
      uiVersion: "v1",
      isDisabled: true,
      class: "border-outline-input-disabled hover:border-outline-input-disabled",
    },
  ],
});

export const chevronStyles = customTv({
  base: "size-lg shrink-0 text-foreground-secondary transition-transform duration-200 ml-xs",
  variants: {
    isOpen: {
      true: "rotate-180",
      false: "rotate-0",
    },
    isDisabled: {
      true: "text-text-disabled",
    },
    uiVersion: {
      v1: "size-md",
      v2: "",
    },
  },
});
